import { forwardRef } from 'react';
import { classNames } from '../../utils/classNames';

const RadioButton = forwardRef(function RadioButton({ id, label, description, className, ...props }, ref) {
  return (
    <label htmlFor={id} className={classNames('flex cursor-pointer items-start gap-3', className)}>
      <input ref={ref} id={id} type="radio" className="peer sr-only" {...props} />
      <span className="mt-0.5 grid size-4 shrink-0 place-items-center rounded-full border border-border-strong bg-white transition after:size-2 after:rounded-full after:bg-white after:content-[''] peer-checked:border-primary-600 peer-checked:bg-primary-600 peer-focus-visible:ring-4 peer-focus-visible:ring-primary-500/15 peer-disabled:opacity-50" />
      <span>
        <span className="block text-sm font-medium text-content-primary">{label}</span>
        {description && <span className="mt-0.5 block text-xs text-content-muted">{description}</span>}
      </span>
    </label>
  );
});

export default RadioButton;
